
import { pushEvent } from './pushEvent'

export function pushMmbClickedEvent(pnr: string, ref: string) {
  pushEvent({ event: 'mmb_clicked', data: { booking_reference: pnr, ref }})
}
